module.exports = __webpack_public_path__ + "img/kpp-gate.c85d6f86.svg";